import { render, staticRenderFns } from "./objetos.vue?vue&type=template&id=cd58d06c&"
import script from "./objetos.vue?vue&type=script&lang=js&"
export * from "./objetos.vue?vue&type=script&lang=js&"
import style0 from "./objetos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports